import { useQuery } from '@tanstack/react-query'
import client from '@/ports/api-client'

const useTenantApplications = tenantId => {
  const { data } = useQuery({
    queryKey: ['tenant-applications', tenantId],
    queryFn: () => client.get('/applications/users/' + tenantId),
    enabled: !!tenantId
  })
  return data
}

export default useTenantApplications
